var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"root"}},[_c('keep-alive',{attrs:{"include":['IndexPage']}},[_c('router-view',{staticClass:"router-view"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }